import { V as _, a as i, b as c } from "./dev-D3SS6qhA.js";
const a = /,/g, h = "-->";
class n extends _ {
  parse(e, t) {
    var r, u;
    if (e === "")
      this._cue && (this._cues.push(this._cue), (u = (r = this._init).onCue) == null || u.call(r, this._cue), this._cue = null), this._block = i.None;
    else if (this._block === i.Cue)
      this._cue.text += (this._cue.text ? `
` : "") + e;
    else if (e.includes(h)) {
      const s = this._parseTimestamp(e, t);
      s && (this._cue = new c(s[0], s[1], s[2].join(" ")), this._cue.id = this._prevLine, this._block = i.Cue);
    }
    this._prevLine = e;
  }
  _parseTimestamp(e, t) {
    return super._parseTimestamp(e.replace(a, "."), t);
  }
}
function T() {
  return new n();
}
export {
  n as SRTParser,
  T as default
};
